import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

/**
 * @memo service 名などについては下記を参照
 * @reference https://www.notion.so/enechain/Datadog-13531f88099180b2bf81c61cc936aa0d?pvs=4
 */
export function initDatadog(): void {
  if (
    import.meta.env.VITE_DD_APPLICATION_ID !== '' &&
    import.meta.env.VITE_DD_CLIENT_TOKEN !== '' &&
    import.meta.env.VITE_DD_ENV !== '' &&
    import.meta.env.VITE_DD_ENV !== 'local'
  ) {
    const isProduction = import.meta.env.VITE_DD_ENV === 'prod'

    datadogRum.init({
      applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
      clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'eclear-portal',
      sessionSampleRate: isProduction ? 100 : 10,
      sessionReplaySampleRate: isProduction ? 100 : 10,
      traceSampleRate: isProduction ? 100 : 10,
      trackResources: true,
      trackUserInteractions: true,
      env: import.meta.env.VITE_DD_ENV,
      defaultPrivacyLevel: isProduction ? 'mask' : 'allow',
      allowedTracingUrls: [import.meta.env.VITE_API_URL],
      version:
        import.meta.env.VITE_COMMIT_SHA !== ''
          ? import.meta.env.VITE_COMMIT_SHA
          : 'local',
    })
    datadogRum.startSessionReplayRecording()

    datadogLogs.init({
      clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'eclear-portal',
      forwardErrorsToLogs: true,
      forwardConsoleLogs: ['error', 'warn'],
      sessionSampleRate: 100,
      env: import.meta.env.VITE_DD_ENV,
      version:
        import.meta.env.VITE_COMMIT_SHA !== ''
          ? import.meta.env.VITE_COMMIT_SHA
          : 'local',
    })
  }
}
